import { EnvironmentInterface } from '@/environments/interfaces/environment.interface';

export const environment: EnvironmentInterface = {
  production: false,
  apiUrl: 'https://instructor-match-api-dev.crio-server.com/api/admin',
  language: 'en',
  googleMapsApiKey: 'AIzaSyBxp16N6jnv5oWLkzZoDX69KdBBJ9LI5tY',
  googlePlayAppUrl: '',
  appStoreAppUrl: '',
};
